export default __webpack_public_path__ + "static/media/bell-off.2de25e51.svg";